export const maintenanceSummaryColumnKeys = [
  'salesResponsible',
  'creator',
  'projectName',
  'customer',
  'quotationNumber',
  'revision',
  'team',
  'businessUnit',
  'totalContractPrice',
  'updatedAt',
  'createdAt',
  'countryOfInstallation',
  'engineers',
  'manager',
  'projectStartDate',
  'projectEndDate',
  'endCustomer',
  'profitCenter',
  'grossMargin',
  'offerSubmissionDate',
  'SISIC',
  'isSiemensStandardTerms',
  'GCKCode',
  'requirePhysicalSignature',
  'wbsNumber',
  'customerPONumber',
  'site',
  'customerReference',
  'newOrRenewal',
  'status',
  'subSystemName',
  'contractAmountPerMonth',
  'financialYear',
  'upcomingQuotationNumber',
  'maintenanceLostReason',
  'upcomingQuotationStatus',
  'cRSPInUse',
  'year',
  'remainMonth',
  'equipmentIds',
  'existingWBS',
  'previousQuotationNumber',
  'maintenanceLostDetailedReason',
]
